import React from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import MenuSuperAdmin from "./Menus/MenuSuperAdmin";
import { getCompany } from "../../actions/company/company";
import { getAdmin, deleteAllAdminNotifs } from "../../actions/admin/admin";
import { getRgpd } from "../../actions/rgpd/rgpd";
import { getUser } from "../../actions/user/user";
import CompanyListing from "../company/CompanyListing/CompanyListing";
import Stats from "../stats/Stats";
import { FormattedMessage } from "react-intl";
import NotificationModal from "../../components/sub/modals/NotificationModal";
import { Alert } from "react-bootstrap";

class Homepage extends React.Component {
  constructor(props) {
    super(props);

    this.state = { notifModals: null, isMinimized: false };
  }

  componentWillMount() {
    Promise.all([
      this.props.onGetCompany(),
      this.props.onGetRgpd(),
      this.props.onGetUsers(),
      this.props.onGetAdmin(),
    ]);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.company.length !== 0 &&
      this.props.admin.crm_notifs &&
      this.props.admin.crm_notifs.length !== 0 &&
      (prevProps.admin !== this.props.admin ||
        prevProps.company !== this.props.company ||
        prevState.isMinimized !== this.state.isMinimized)
    ) {
      let title = <FormattedMessage id="Notification.Automatic.Detect.Title" />;
      let content = (
        <>
          {" "}
          <Alert variant="danger">
            <FormattedMessage id="Notification.Automatic.Detect" />
          </Alert>
          <table className="table tablee4coll">
            <thead>
              <tr className="d-flex align-items-center">
                <th scope="col" className="col col-2">
                  <FormattedMessage id="Company" />
                </th>
                <th scope="col" className="col col-5">
                  <FormattedMessage id="Reason" />
                </th>
                <th scope="col" className="col col-5">
                  <FormattedMessage id="Error.Origin" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.props.admin.crm_notifs.map((notif, index) => {
                return (
                  <tr key={index} className="d-flex align-items-center">
                    <td className="col col-2">
                      {this.getCompanyName(notif.company_id)}
                    </td>
                    <td className="col col-5">{notif.reason}</td>
                    <td className="col col-5 text-break">{notif.error}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      );
      this.setState({
        notifModals: (
          <NotificationModal
            showModal={true}
            title={title}
            variant="danger"
            content={content}
            successCallback={() => this.closeNotifModal()}
            closeModal={() => this.closeNotifModal()}
            modalType="notification"
            isMinimized={this.state.isMinimized}
            setState={(data) => {
              this.setState(data);
            }}
          />
        ),
      });
    }
  }

  closeNotifModal() {
    this.setState({ notifModals: null });
    this.props.onDeleteAllAdminNotifs(this.props.admin);
  }

  getCompanyName(id) {
    if (this.props.company) {
      for (let company of this.props.company) {
        if (company._id === id) {
          return company.name;
        }
      }
    }
    return id;
  }

  render() {
    var switchComponent = <SwitchComponent />;

    return (
      <React.Fragment>
        <MenuSuperAdmin />
        {this.state.notifModals}
        <div className="container-fluid p-3 animated fadeIn maindiv min-vh-100">
          {switchComponent}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rgpd: state.rgpd,
    company: state.company,
    admin: state.admin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDeleteAllAdminNotifs: () => dispatch(deleteAllAdminNotifs()),
    onGetCompany: () => dispatch(getCompany()),
    onGetRgpd: () => dispatch(getRgpd()),
    onGetUsers: () => dispatch(getUser()),
    onGetAdmin: () => dispatch(getAdmin()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);

class SwitchComponent extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/home/company" component={CompanyListing} />
        <Route path="/home/stats" component={Stats} />
      </Switch>
    );
  }
}
